import { render, staticRenderFns } from "./recommendSettingsDialog.vue?vue&type=template&id=675b3ac1&scoped=true"
import script from "./recommendSettingsDialog.vue?vue&type=script&lang=js"
export * from "./recommendSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./recommendSettingsDialog.vue?vue&type=style&index=0&id=675b3ac1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675b3ac1",
  null
  
)

export default component.exports